document.addEventListener('DOMContentLoaded', () => {
  const menuModal = document.querySelector('.js-menuModal');

  if (!menuModal) {
    return;
  }

  const menuOpenButton = document.querySelector('.js-menuOpen');
  const menuBackButton = document.querySelector('.js-menuBack');

  const toggleMenu = (show) => {
    menuModal.classList.toggle('is-show', show);
  };

  menuOpenButton?.addEventListener('click', () => toggleMenu(true));
  menuBackButton?.addEventListener('click', () => toggleMenu(false));

  $(document).on('favorites-cleared', () => {
    alert('保存した動画をクリアしました。');
    location.reload();
  });
});
